import BASE_URL from "./config";
import axios from "axios";
const UserFetch = async () => {
  try {
    const token = localStorage.getItem("access_token"); // Get the token from localStorage
    const headers = {
      Authorization: `Bearer ${token}`, // Set the Authorization header with the token
    };
    const response = await axios.get(`${BASE_URL}/get-user-data`, {
      headers,
    });
    
    // Check if response and data exist
    if (!response || !response.data) {
      throw new Error('Invalid response from server');
    }
    
    return response;
  } catch (error) {
    console.error('UserFetch error:', error);
    // Re-throw the error so calling code can handle it
    throw error;
  }
};

export default UserFetch;
